<template>
	<div>
		<div class="footer">
			<div class="homebottom">
				<div align="center" class="bottom">
					<a
						href="https://www.drcnet.com.cn/statement"
						target="_blank"
						>网站声明</a
					>
					|
					<a
						href="http://company.drcnet.com.cn/lxwm.html#/contact"
						target="_blank"
						>联系我们</a
					>
					<!-- <a
						href="javascript:void(0)"
						onclick="SetHome(this,'http://worldeconomy.drcnet.com.cn');"
						>设为首页</a
					> -->
					|
					<a
						href="http://misc.drcnet.com.cn/DRCNet.Users.Web/User/UserSuggestAdd1.aspx"
						target="_blank"
						>意见和建议</a
					>
					|
					<a href="mailto:chiefeditor@drcnet.com.cn" target="_blank"
						>总监信箱</a
					>
				</div>
				<table
					cellspacing="8"
					width="1140"
					align="center"
					border="0"
					style="margin: 0px auto"
				>
					<tbody>
						<tr>
							<td colspan="3" align="center" height="60px">
								<p>
									<a
										href="http://www.drcnet.com.cn"
										target="_self"
										><img
											src="../../../../assets/imgs/public/logo_whiteBackground.png"
											height="40"
											hspace="4"
											border="0"
									/></a>
								</p>
							</td>
						</tr>
						<tr>
							<td
								valign="bottom"
								align="middle"
								width="352"
								height="10"
								class="bottom"
							>
								<div class="center-style" align="center">
									Copyright © 1998-{{ newYear }} DRCnet. All
									Rights Reserved 版权所有 国研网
									<img
										style="vertical-align: -5px"
										src="../../../../assets/imgs/footer/copyright.png"
										alt=""
									/>
								</div>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<!-- <div class="footer-bottom">
									<a
										href="https://beian.miit.gov.cn/"
										target="_blank"
										class="ipc"
										>增值电信业务经营许可证 京ICP证030059号</a
									>
									<a
										href="https://www.drcnet.com.cn/announcement/zizhiimg4"
										target="_blank"
										class="ipc"
										>网络出版服务许可证：网出证京字第420号</a
									>
									<a
										href="https://www.drcnet.com.cn/announcement/zizhiimg3"
										target="_blank"
										class="ipc"
										>出版物经营许可证：新出发京零字第东230083号</a
									>
									<a
										href="https://www.drcnet.com.cn/announcement/zizhiimg2"
										target="_blank"
										class="ipc"
										>增值电信业务经营许可证 京B2-20070136</a
									>
									<div class="footer-bottom-text">
										建议浏览器：IE9+、火狐、谷歌
									</div>
								</div> -->
		</div>
		<div class="footer-bottom">
			<a
				href="https://www.drcnet.com.cn/announcement/zizhiimg1"
				style="text-decoration: none"
				target="_blank"
				>增值电信业务经营许可证 京ICP证030059号</a
			>
			<a
				href="https://www.drcnet.com.cn/announcement/zizhiimg2"
				style="text-decoration: none"
				target="_blank"
				>增值电信业务经营许可证 京B2-20070136</a
			>
			<a
				href="https://www.drcnet.com.cn/announcement/zizhiimg3"
				style="text-decoration: none"
				target="_blank"
				>出版物经营许可证 新出发京批字第直210398号</a
			>
			<a
				target="_blank"
				href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010102002958"
				class="beian_a"
			>
				<p
					style="
						height: 20px;
						line-height: 20px;
						margin: 0px 35px 0px 0px;
						font-size: 13px;
					"
				>
					京公网安备 11010102002958号
				</p></a
			>
			<div
				class=""
				style="
					height: 20px;
					line-height: 20px;
					margin: 0px 0 0px 0px;
					font-size: 13px;
				"
			>
				建议浏览器：IE9+、火狐、谷歌
			</div>
		</div>
	</div>
</template>
<script>
import { divide } from 'lodash';

export default {
	name: '',
	components: {},
	mixins: [],
	props: {},
	data() {
		return { newYear: new Date().getFullYear() };
	},
	computed: {},
	watch: {},
	mounted() {},
	methods: {},
};
</script>
<style lang="less" scoped>
/* 保留用户原本的蓝色医疗风样式（不要替换成 edu 的浅灰风） */
.footer-bottom {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: 40px;
	background: #005797;
	color: #b6d9f7;
}
.footer-bottom a {
	color: #b6d9f7;
	font-size: 13px;
	text-decoration: none;
	height: 20px;
	line-height: 21px;
	margin-right: 15px;
}
.footer {
	border-top: 6px solid #015293;
	background: #006ab8;
	padding: 30px;
	letter-spacing: 0.2px;
}

.homebottom {
	max-width: 1140px;
	padding-top: 20px;
	margin: auto;
	color: #fff;
	font-size: 13px;
	line-height: 18px;
	background: #006ab8;
	.ipc {
		text-decoration: none;
		&:not(:last-child) {
			margin-right: 12px;
		}
	}
}

.homebottom a {
	color: #fff;
	font-size: 13px;
	margin-left: 10px;
	margin-right: 10px;
}

.homebottom td a {
	text-decoration: underline;
	font-size: 13px;
}
.beian_a {
	background: url('@/assets/imgs/footer/filingForTheRecord.png') right center
		no-repeat;
	background-repeat: no-repeat;
	display: inline-block;
	text-decoration: none;
}

/* 借鉴 edu 的移动端响应式样式（不动结构、配色） */
@media screen and (max-width: 769px) {
	.footer {
		padding: 24px;
	}
	.homebottom {
		font-size: 12px;
	}
	.homebottom a {
		font-size: 12px;
	}
	.homebottom table {
		width: 100%;
	}
	.footer-bottom {
		flex-wrap: wrap;
		height: auto;
		padding: 8px 10px;
		gap: 6px 8px;
		font-size: 12px;
		line-height: 1.6;
		flex-direction: column;
	}
	.footer-bottom a {
		font-size: 12px;
	}
	.footer-bottom p,
	.footer-bottom div {
		font-size: 12px !important;
		margin-left: 0 !important;
		margin-right: 0;
		line-height: 1.6;
	}
}
</style>
